export const PERMISSION_STATUS = {
  NOT_FOUND: 'NotFound',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  REQUESTED: 'Requested', // Pending
  REVOKED: 'Revoked',
};
